import DatePicker from 'vue2-datepicker';
import commonHelper from '@/app/utility/common.helper.utility';
import splitDetails from './splitDetails';
export default {
  name: 'invoiceLoaderDetails',
  watch: {
    // currentPage: function() {
    //   this.getInvLoaderDtls();
    // },
    // perPage: function() {
    //   this.currentPage = 1;
    //   this.getInvLoaderDtls();
    // }
  },
  props: ['invLoaderRowSelected'],
  components: { DatePicker, splitDetails },
  data() {
    return {
      loader: false,
      headerDetails: {
        po_header_id: null,
        po_num: null,
        po_status: null,
        inv_num: null,
        inv_amt: null,
        show_inv_amt: null,
        first_party_gstn: null,
        third_party_gstn: null,
        currency: null,
        inv_agreement: null,
        inv_status: null,
        liability_account: null,
        dif_amount: null,
        payment_term: null,
        inv_date: null,
        due_date: null,
        uploaded_document: null,
        vendor_inv_id: null,
        le_id: null,
        le_name: null,
        vendor_id: null,
        vendor_name: null,
        ou_id: null,
        vendor_site_id: null,
        approval_status: null,
        approval_status_key: null,
        wf_inprocess_hdr_id: null,
        wf_inprocess_dtl_id: null,
        seq_order: null,
        vendor_site_name: null,
        exchange_rate: null,
        actual_gr_date: null,
        gl_date: null,
        period_name: null,
        material_received_by: null,
        receipt_num: null,
        buyer_name: null,
        buyer_email_id: null,
        buyer_emp_id: null,
        po_creation_date: null,
        erp_le_id: null,
        remarks: null,
        grn_attach_flag: false,
        manual_invoice: null
      },
      editMode: false,
      operatingUnit: { value: null, text: null },
      invoiceLineData: [],
      invoiceLineFields: [
        {
          key: 'manual_invoice_line_id',
          label: 'Manual Invoice Line No.'
        },
        {
          key: 'item_description',
          label: 'Description'
        },
        {
          key: 'po_price',
          label: 'PO Price',
          class: 'col-width-fix'
        },
        {
          key: 'deliver_qty',
          label: 'Qty. Being Delivered',
          class: 'qty-width-fix'
        },
        {
          key: 'hsn_sac',
          label: 'HSN/SAC',
          class: 'col-width-fix'
        },
        { key: 'taxable_amount', class: 'tax-amt-fix' },
        {
          key: 'tax_amount',
          class: 'text-fix-po'
        },
        {
          key: 'tax_details',
          label: 'Tax',
          stickyColumn: true
        },
        {
          key: 'split',
          stickyColumn: true
        }
      ],
      totalTaxableAmt: null,
      freightExcTax: null,
      taxExcFreight: null,
      vendorInvId: null,
      isCurrencyDisabled: false,
      showPreviewTaxModal: false,
      previewTaxData: [],
      previewTaxFields: [
        { key: 'tax_type', class: 'tax-type-fix' },
        { key: 'taxable_amount', class: 'col-width-acc' },
        { key: 'tax_rate', class: 'tax-type-fix' },
        { key: 'amount', label: 'Tax Amount', class: 'tax-type-fix' },
        {
          key: 'tax_category_name',
          label: 'Tax Category',
          class: 'tax-cat-fix'
        },
        { key: 'rcm_flag', label: 'RCM', stickyColumn: true }
      ],
      showSplitModal: false,
      splitLineData: null
    };
  },
  mounted() {
    if (this.invLoaderRowSelected) {
      this.vendorInvId = this.invLoaderRowSelected.vendor_inv_id;
      this.getInvoiceLoaderDetailsById();
    }
  },
  methods: {
    getInvoiceLoaderDetailsById() {
      const payload = {
        hdrId: this.vendorInvId
      };
      this.loader = true;
      this.$store
        .dispatch('invoiceLoader/getInvLoaderDtlsById', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.headerDetails = result;
            this.operatingUnit.text = result.manual_ou_name;
            this.operatingUnit.value = result.manual_ou_id;
            this.invoiceLineData = result.invoice_dtls;
            this.headerDetails.show_inv_amt = commonHelper.formatAmountWithoutCurrency(
              result.inv_amt
            );
            this.validateCurrency();
            this.getTotalTaxAmount();
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getTotalTaxAmount() {
      const payload = {
        vendor_inv_id: this.vendorInvId
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/getTotalTaxAmount', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.taxableAmountWithoutCurrency =
              response.data.data.taxable_amount_sum;
            this.taxAmountWithoutCurrency = response.data.data.tax_amount_sum;
            this.totalTaxableAmt = commonHelper.formatAmountWithoutCurrency(
              response.data.data.taxable_amount_sum
            );
            this.freightExcTax = commonHelper.formatAmountWithoutCurrency(
              response.data.data.taxable_amount_line_sum
            );
            this.taxExcFreight = commonHelper.formatAmountWithoutCurrency(
              response.data.data.tax_amount_sum
            );
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    validateCurrency() {
      const payload = {
        legal_entity_id: this.headerDetails.erp_le_id
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/validateCurrencyExchangeRate', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            const result = response.data.data.data;
            if (result) {
              if (result.CURRENCY_CODE == this.headerDetails.currency) {
                this.isCurrencyDisabled = true;
              } else {
                this.isCurrencyDisabled = false;
              }
            }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    showHidePreviewTaxModal(flag, item) {
      this.showPreviewTaxModal = flag;
      if (flag) {
        this.previewTaxData = item.tax_details;
      }
    },
    formattingAmount(amount) {
      return commonHelper.formatAmountWithoutCurrency(amount);
    },
    splitFunction(item) {
      this.splitLineData = item;
      this.showHideSplitModal(true);
    },
    showHideSplitModal(flag) {
      this.showSplitModal = flag;
    }
  }
};
